const items = [
	{
		id: 1,
		name: "agentType.life",
	},
	{
		id: 2,
		name: "agentType.vehicle",
	},
	{
		id: 3,
		name: "agentType.all",
	}
];

export default items;